import styled from 'styled-components'

export const Decorator = styled.div`
  display: flex;
  outline: 1px solid var(--border-alert);
  outline-offset: var(--space-100);
  position: relative;
`

export const Label = styled.div`
  position: absolute;
  bottom: -4px;
  right: -4px;
  background: var(--bg-alert);
  padding: var(--space-100) var(--space-200);
  z-index: 1;
  color: var(--text-alert-tertiary);
  text-transform: uppercase;
  font-size: 10px;
  font-weight: var(--font-weight-semibold);
  border-top-left-radius: var(--radius-brand);
`
